module.exports = __webpack_public_path__ + "img/conny-stage6-blink.3b83dc81.png";